import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { PROCESS } from "../data/content";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <SectionHeader
          label="Our Process"
          title="A proven path to results"
          desc="Six deliberate chapters that turn your requirements into measurable business outcomes."
        />

        <div className="mt-16 relative">
          {/* Vertical connector line */}
          <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-jo-accent/40 via-jo-primary/20 to-transparent" />

          <div className="space-y-6 md:space-y-0">
            {PROCESS.map((p, i) => {
              const left = i % 2 === 0;
              return (
                <div
                  key={p.step}
                  className="md:grid md:grid-cols-2 md:gap-12 items-center relative"
                >
                  <Reveal
                    y={30}
                    className={`${left ? "md:text-right md:pr-12" : "md:col-start-2 md:pl-12"}`}
                  >
                    <motion.div
                      data-testid={`process-step-${i}`}
                      whileHover={{ y: -4 }}
                      className="glass rounded-3xl p-7 my-4 md:my-6"
                    >
                      <div
                        className={`flex items-center gap-4 ${left ? "md:flex-row-reverse" : ""}`}
                      >
                        <span className="text-5xl font-bold bg-gradient-to-br from-jo-accent to-jo-primary bg-clip-text text-transparent leading-none">
                          {p.step}
                        </span>
                        <div className={left ? "md:text-right" : ""}>
                          <h3 className="text-lg font-semibold text-jo-primary">{p.title}</h3>
                        </div>
                      </div>
                      <p className="mt-3 text-sm text-slate-600 font-light leading-relaxed">
                        {p.desc}
                      </p>
                    </motion.div>
                  </Reveal>

                  {/* Center dot */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 h-4 w-4 rounded-full bg-jo-highlight ring-4 ring-white shadow" />

                  {i < PROCESS.length - 1 && (
                    <div className="flex md:hidden justify-center py-1 text-jo-accent">
                      <ArrowDown size={20} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
